/**
 * @generated SignedSource<<c5841a38c219f45be18008d9117e53e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountSettings_Club$data = {
  readonly supportsPublic: boolean;
  readonly " $fragmentType": "AccountSettings_Club";
};
export type AccountSettings_Club$key = {
  readonly " $data"?: AccountSettings_Club$data;
  readonly " $fragmentSpreads": FragmentRefs<"AccountSettings_Club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountSettings_Club",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsPublic",
      "storageKey": null
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "dde50a4244a75418d65e4a1b9f928eb1";

export default node;
